var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { IdentifiableMap, RArray, toPairs } from "../../collections";
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { CustomParameterInstanceFactory } from "./CustomParameterInstanceFactory";
import { ModifierInstanceFactory } from "./ModifierInstanceFactory";
import { ProductInstance } from "./ProductInstance";
import { ProductInstancePartsFactory } from "./ProductInstancePartsFactory";
let ProductInstanceFactory = class ProductInstanceFactory {
    constructor(modifierInstanceFactory, customParameterInstanceFactory, productInstancePartsFactory) {
        this.modifierInstanceFactory = modifierInstanceFactory;
        this.customParameterInstanceFactory = customParameterInstanceFactory;
        this.productInstancePartsFactory = productInstancePartsFactory;
        makeImmutable(this);
    }
    fromProductTypeIds(productTypeIds) {
        const productTypes = productTypeIds.map((productTypeId) => ({
            productTypeId,
            productConfig: { customParameterInstances: {}, modifierInstances: {} },
        }));
        switch (productTypes.length) {
            case 1:
                return this.fromStorageData({
                    commonConfig: { customParameterInstances: {}, modifierInstances: {} },
                    parts: { type: "SinglePart", part: productTypes[0] },
                });
            case 2:
                return this.fromStorageData({
                    commonConfig: { customParameterInstances: {}, modifierInstances: {} },
                    parts: {
                        type: "Halves",
                        first: productTypes[0],
                        second: productTypes[1],
                    },
                });
            default:
                return null;
        }
    }
    fromStorageData(storageData) {
        const commonModifierInstances = new RArray(toPairs(storageData.commonConfig.modifierInstances)).mapOptional(([modifierTypeId, data]) => this.modifierInstanceFactory.fromStorageData({
            modifierTypeId,
            modifierSettingsProvider: (modifierType) => modifierType.defaultSettings,
            storageData: data,
        }));
        const customParameterInstances = new RArray(toPairs(storageData.commonConfig.customParameterInstances)).mapOptional(([customParameterTypeId, data]) => this.customParameterInstanceFactory.fromStorageData({
            customParameterTypeId,
            storageData: data,
        }));
        const parts = this.productInstancePartsFactory.fromStorageData(storageData.parts);
        if (parts === null) {
            return null;
        }
        return new ProductInstance({
            customParameterInstances: IdentifiableMap.fromIterable("typeId", customParameterInstances),
            commonModifierInstances: IdentifiableMap.fromIterable("typeId", commonModifierInstances),
            parts,
        });
    }
};
ProductInstanceFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ModifierInstanceFactory !== "undefined" && ModifierInstanceFactory) === "function" ? _a : Object, typeof (_b = typeof CustomParameterInstanceFactory !== "undefined" && CustomParameterInstanceFactory) === "function" ? _b : Object, typeof (_c = typeof ProductInstancePartsFactory !== "undefined" && ProductInstancePartsFactory) === "function" ? _c : Object])
], ProductInstanceFactory);
export { ProductInstanceFactory };
